import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { api_menu_list } from '../../states/selector'
import { Button, ButtonGroup, Box, Typography } from '@mui/material'
import { TextField } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import axios from 'axios';
import { format } from 'date-fns'

import { CONFIG } from '../../states/settings';


// TODO:
// 関数内に閉じ込めたいが、どうしてもuseEffect内で代入できなかった
let all_items = []

const Search = ()=>{
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)
  let [ matched_items, setMatchedItems ] = useState([])
  let [ results_num,   setResultsNum   ] = useState(0)

  let partial_word = (word, q) => {
    let range = 25
    let p = word.indexOf(q)

    if (p < 0){ return '' }

    let suffix = ' __', prefix = '__ '
    let head = p - range
    if ( head < 0 ) {
      head = 0
      prefix = ''
    }
    return prefix + word.substr(head, range*2) + suffix
  }

  let onChange = e => {
    let q = e.target.value
    let filterd_items = []

    all_items.forEach(category_item => {
      let z = category_item.messages.filter(line=>{
        let regex = new RegExp(q,'ig')
        return line.title.match(regex) || line.body.match(regex)
      })

      z.forEach(v=>{
        v.partial = partial_word(v.body, q)
        v.name = category_item.name
        filterd_items.push(v)
      })
    })

    setResultsNum(filterd_items.length)
    setMatchedItems(filterd_items)
  }

  let SearchResults = ()=>{
    return (
      <Box
        className='search_results'
        sx={{
          padding: '0 16px',
          margin: 'auto'
        }}
      >
        { matched_items.map(v=>{
          return (
            <Box
              className='search_navlink'
              sx={{
                padding:'10px 0',
                fontSize: '1.2rem',
              }}
            >
              <Link
                to={`${CONFIG.PAGE_ROOT_PATH}/${v.name}/items/${v.id}`}
                style={{
                  color: 'inherit',
                  textDecoration: 'none',
                }}
              >
                <Typography component="p" fontWeight='700' sx={{ padding:'0 4px',fontSize:'1.2rem',lineHeight:1.3 }}>
                  {`【${v.name}】 ${v.title}`} 
                </Typography>
                <Typography component="p" fontWeight='300' sx={{ padding:'0 10px 0 12px',fontSize:'.9rem',lineHeight:1.1 }}>
                  <time style={{margin:"0 10px 0 0"}}>{`${format(new Date(v.sent_at),'yyyy-MM-dd')}`}</time>
                  {`${v.partial}`}
                </Typography>
              </Link>
            </Box>
          )
        }) }
      </Box>
    )
  }

  let store = lines => {
    all_items = lines
  }


  useEffect(()=>{
    (async ()=>{
      let jsons = menu_list.map( v=>axios.get(CONFIG.API.INFO + v.json_file) )
      let lines = []

      for (var i in jsons) {
        let p = await jsons[i]
        lines.push(p.data)
      }

      store(lines)
    })();
  }, [])

  return (
    <>
      <Box sx={{ textAlign:'center', padding:'20px 0' }}>
        <TextField sx={{ width:'80vw' }} label='検索ワード入力してください' margin='normal' onChange={ onChange }/>
        <Typography component="h5" variant="h7" fontWeight='300' sx={{ padding:'12px 0 0',fontSize:'1rem' }}>
          検索結果：<b>{ results_num }</b> 件
        </Typography>
      </Box>
      <SearchResults />
    </>
  )
}


export default Search
